import React from 'react';
import {RoleGuard} from "../../components/PermissionGuard";
import {UserManagementFeature} from "../../features/userManagement/components/UserManagementFeature";

const ALLOWED_ROLES = ['god', 'admin']

const UserManagementPage = ({
  userToken,
  userRole,
}) => (
  <RoleGuard
    role={userRole}
    userToken={userToken}
    allowedRoles={ALLOWED_ROLES}
  >
    <UserManagementFeature
      userToken={userToken}
      userRole={userRole}
    />
  </RoleGuard>
);

export default UserManagementPage;
